/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { observable } from 'mobx';

/**
 * Represents state of the expand button.
 */
export class ExpandButtonState {
    @observable public extraProductsCount: number;

    public constructor(extraProductsCount: number) {
        this.extraProductsCount = extraProductsCount;
    }
}
